import script from "./OrderEditClient.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderEditClient.vue?vue&type=script&setup=true&lang=js"

import "./OrderEditClient.vue?vue&type=style&index=0&id=7605b165&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7605b165"]])

export default __exports__